export default {
  XS: 0,
  SM: 576,
  MD: 768,
  LG: 1367,
  XL: 1920,
  XXL: 2560,
};
